import React, { useContext, useState, useEffect } from "react";
import InternalPageHeader from "../../components/media/InternalPageHeader";
import ImgTextCard from "../../components/media/ImgTextCard";
import ArticleText from "../../components/text/ArticleText";
import ImgTextCardTyler from "../../components/media/ImgTextCardTyler";
import TitleTextArticle from "../../components/text/TitleTextArticle";
import { Container, Row, Col, Accordion, ListGroup } from "react-bootstrap";
import bgInternalImage from "../../images/Smathers-Grand-Reading-Room-Zoom-Background-2752x1392.jpg";
import booksStockImage from "../../images/booksOnShelf.jpg";
import otherBookImage from "../../images/archivals/other-book-with-qr.jpg";
import Footer from "../../components/Footer";
import { accrpArchivalsContext } from "../../contexts/ACCRPArchivalDocsContext";
import { Skeleton } from "@mui/material";

const ACCRPArchivalDocs = () => {
  const [archives2019Data, setArchives2019Data] = useState([]);
  const [archives2020Data, setArchives2020Data] = useState([]);
  const [archives2021Data, setArchives2021Data] = useState([]);
  const [archives2022Data, setArchives2022Data] = useState([]);
  const [archives2023Data, setArchives2023Data] = useState([]);
  const [archives2025Data, setArchives2025Data] = useState([]);
  const [isArchivesDataLoading, setIsArchivesDataLoading] = useState(true);

  const { accrpArchivals, loading } = useContext(accrpArchivalsContext);

  const archivesSkeletonTiles = Array.from({ length: 3 }).map((_, index) => (
    <Col
      xs={12}
      sm={12}
      md={6}
      lg={4}
      xl={4}
      style={{
        textAlign: "center",
        color: "#00283C",
        padding: "1%",
      }}
      key={index}
    >
      <div
        style={{
          borderRadius: "3%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "6%",
          background: "#FAFAFA",
          height: "100px",
          boxShadow: "1px 2px 6px rgba(0, 0, 0, 0.25)",
        }}
      >
        <Skeleton variant="text" animation="wave" height={20} width="80%" />
        <Skeleton
          variant="text"
          animation="wave"
          height={20}
          width="60%"
          style={{ marginTop: 8 }}
        />
      </div>
    </Col>
  ));

  useEffect(() => {
    if (accrpArchivals) {
      getArchivalDocs();
    }
  }, [accrpArchivals, loading]);

  const getArchivalDocs = () => {
    const archives2019 = accrpArchivals.filter((item) =>
      item.Date.includes(2019)
    );
    const archives2020 = accrpArchivals.filter((item) =>
      item.Date.includes(2020)
    );
    const archives2021 = accrpArchivals.filter((item) =>
      item.Date.includes(2021)
    );
    const archives2022 = accrpArchivals.filter((item) =>
      item.Date.includes(2022)
    );
    const archives2023 = accrpArchivals.filter((item) =>
      item.Date.includes(2023)
    );
    const archives2025 = accrpArchivals.filter((item) =>
      item.Date.includes(2025)
    );

    const archives2019Data = archives2019.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));

    const archives2020Data = archives2020.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const archives2021Data = archives2021.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const archives2022Data = archives2022.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const archives2023Data = archives2023.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const archives2025Data = archives2025.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={file.Link}
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));

    setArchives2019Data(archives2019Data);
    setArchives2020Data(archives2020Data);
    setArchives2021Data(archives2021Data);
    setArchives2022Data(archives2022Data);
    setArchives2023Data(archives2023Data);
    setArchives2025Data(archives2025Data);
    setIsArchivesDataLoading(false);
  };

  return (
    <main className="archivalDocs">
      <InternalPageHeader
        pageHeading={"ACCRP Resources"}
        pageSubHeading={"Archival Documents"}
        inPageBGImage={bgInternalImage}
      />

      <TitleTextArticle h2TitleText={""} />
      <ArticleText
        articleText={`This section includes media and archival resources associated with the activities of the ACCRP and its eight subcommittees since 2019. We have compiled the weblinks for all our publicly held events, available for viewing on YouTube, as well as any available PDF documents and flyers, some of which include soil collection ceremonies, historical marker dedications and more. Those files have been organized chronologically. `}
      />
      <Container className="archivalAccordion">
        <Row>
          <Col sm={12}>
            <Accordion defaultActiveKey={["0"]} alwaysOpen="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2019</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2019Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>

      <Container className="archivalAccordion">
        <Row>
          <Col sm={12}>
            <Accordion defaultActiveKey={["0"]} alwaysOpen="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2020</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2020Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>

      <Container className="archivalAccordion">
        <Row>
          <Col sm={12}>
            <Accordion defaultActiveKey={["0"]} alwaysOpen="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2021</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2021Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>

      <Container className="archivalAccordion">
        <Row>
          <Col sm={12}>
            <Accordion defaultActiveKey={["0"]} alwaysOpen="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2022</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2022Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>

      <Container className="archivalAccordion">
        <Row>
          <Col sm={12}>
            <Accordion defaultActiveKey={["0"]} alwaysOpen="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2023</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2023Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>

      <Container className="archivalAccordion">
        <Row>
          <Col sm={12}>
            <Accordion defaultActiveKey={["0"]} alwaysOpen="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>2025</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {isArchivesDataLoading
                      ? archivesSkeletonTiles
                      : archives2025Data}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>

      <Container className="addMarginArchivePg">
        <Row>{loading && <p style={{ color: "#FFFFFF" }}> Loading...</p>}</Row>
      </Container>
      <Footer />
    </main>
  );
};

export default ACCRPArchivalDocs;
